<template>
  <div class="part2-wrap">
    <div class="title-wrap">
      <v-title class="title" :text="'打造安全、全面、高性能的区块链生态系统'"></v-title>
    </div>
    <div class="con">
      <div class="pics">
        <base-service></base-service>
        <safe-service></safe-service>
        <value-exploration></value-exploration>
      </div>
    </div>
  </div>
</template>

<script>
  import VTitle from "../plug/VTitle";
  import BaseService from "./pics/BaseService";
  import SafeService from "./pics/SafeService";
  import ValueExploration from "./pics/ValueExploration";

  export default {
    components: {
      ValueExploration,
      SafeService,
      BaseService,
      VTitle
    },
    name: "part2"
  }
</script>

<style lang="less" scoped>
  .part2-wrap {
    height: 100%;
    position: relative;
    .title-wrap {
      position: relative;
      height: 20%;
      .title {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -100%);
      }
    }
    .con {
      width: 100%;
      height: 50%;
      min-height: 422px;
      margin-top: 30px;
      left: 0;
      .pics {
        display: flex;
        justify-content: space-between;
        width: 80%;
        height: 100%;
        margin: auto;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/part2/Part2.vue